export default __webpack_public_path__ + "static/media/broken-image.bb349ef2.png";